import React from 'react'
import { List, Stack, Typography } from '@mui/material'
import { ContactListItem } from './ContactListItem'
import { Contact, ContactSection } from '@plug-core/interfaces/common'
import { useTranslation } from 'react-i18next'

export interface IProps {
  contactSections: ContactSection[]
  onContactClick?: (contact: Contact) => void
}

export const ContactList = ({ contactSections, onContactClick }: IProps) => {
  const { t } = useTranslation()

  return (
    <Stack component={List} spacing={1.2} disablePadding>
      {contactSections.map((section) => (
        <React.Fragment key={section.kind}>
          {section.contacts.length > 0 && (
            <Typography>{t(`send.contacts.${section.kind}`)}</Typography>
          )}
          {section.contacts.map((contact) => (
            <ContactListItem key={contact.address} contact={contact} onClick={onContactClick} />
          ))}
        </React.Fragment>
      ))}
    </Stack>
  )
}
